var React = require('react');

function Tabs (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"y":"122","width":"144","height":"2","fill":"#737373","key":1}),React.createElement("rect",{"x":"16","y":"88","width":"112","height":"24","fill":"#D8D8D8","key":2}),React.createElement("rect",{"x":"160","y":"88","width":"112","height":"24","fill":"#D8D8D8","key":3})]);
}

Tabs.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = Tabs;

Tabs.default = Tabs;
